import { SignatureModel } from "../types/SurveyResult";

export interface Result {
    Answer?: string | null;
    Choices?: (string | undefined | null)[] | null;
    FileName?: string | null;
    Signature?: SignatureModel
}

export function hasAnswer(result: Result | undefined): boolean {
    if (!result) return false;

    if (!!result.Signature?.FamilyName || !!result.Signature?.GivenName || !!result.Signature?.HandwrittenSignatureBase64) {
        return true;
    }

    if (result.hasOwnProperty("Answer")) {
        return !!result.Answer;
    }

    if (result.hasOwnProperty("Choices")) {
        return !!result.Choices?.find(choice => !!choice);
    }

    if (result.hasOwnProperty("FileName")) {
        return !!result.FileName;
    }

    return false;
}